import Vec2 from 'vec2';

import { DrawingShape } from '~/core/models';
import { getArrowsFromOutlines } from '~/core/utils';

export const updateArrowsInfo = (
  oldShape: DrawingShape,
  outlinePoints: Vec2[]
): void => {
  const arrows = getArrowsFromOutlines(
    outlinePoints,
    outlinePoints,
    { diagonals: [], cornerIds: [] },
    []
  );

  arrows.forEach((arrow, index) => {
    if (oldShape.arrowsInfo?.[index]) {
      oldShape.arrowsInfo[index] = {
        ...oldShape.arrowsInfo[index],
        path: arrow.path,
        size: arrow.size,
      };
    }
  });
};
